export enum TestId {
    DisconnectDestinationLink = 'disconnect-destination-link',
    TermsConditionsLink = 'terms-conditions-link',
}
